// extracted by mini-css-extract-plugin
export default {"stepsFather":"steps_stepsFather__alOe9","currentStep":"steps_currentStep__LTTDr","step":"steps_step__8d-ls"};